import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";

const GoToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      className={`go-to-top-button border flex justify-center items-center h-8 w-8 rounded-full shadow ${isVisible ? "visible" : ""}`}
      onClick={scrollToTop}
      style={{
        position: "fixed",
        bottom: "10px",
        right: "10px",
        zIndex: 999, // Ensure the button is on top of other content
      }}
    >
      <FaArrowUp />
    </button>
  );
};

export default GoToTopButton;
